<script setup>
    import AnswerRates from '@/components/result/ai-literacy-2026/AnswerRates.vue';
    import SubareaGuide from '@/components/result/ai-literacy-2026/SubareaGuide.vue';
    
    // 학부모용은 아직 API 연동 없이 표시만 확인하는 목업이다
    const myPercentages = [85, 70, 20, 65];
    const schoolPercentages = [75, 35, 80, 70];
    const userRole = 'parent';
</script>
<template>
    <div class="report-inner">
        <div class="card-wrap">
            <AnswerRates
                :my-percentages="myPercentages"
                :school-percentages="schoolPercentages"
                :userRole="userRole"
            />            
            <SubareaGuide :userRole="userRole" />
        </div>        
    </div>
</template>